module.exports = __webpack_public_path__ + "fonts/lavanderia-regular.2bd72d3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/mockingbird/fonts/lavanderia-regular.woff
// module id = 388
// module chunks = 0